module.exports = __webpack_public_path__ + "static/nib-italic-pro-07e7507801ad653ab8933282c48ffa3a.woff";